import { Routes, RouterModule } from "@angular/router";
import { RoleDetailsComponent } from "../role-details/role-details.component";
import { UserSelectionComponent } from '../user-selection/user-selection.component';


const routes: Routes = [
    { path: ':RoleName', component: RoleDetailsComponent },
    { path: 'selectUser', loadChildren: () => UserSelectionComponent }
  ];

  export const roleDetailsRouting = RouterModule.forChild(routes);